import { Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './layout/AppLayout';
import { IntroSplash } from './layout/IntroSplash';
import { ALL_ITEMS } from './layout/modules';
import { LoginPage } from './auth/LoginPage';
import { ResetPasswordPage } from './auth/ResetPasswordPage';
import { RequireAuth } from './auth/RequireAuth';
import { CartProvider } from './cart/CartProvider';
import { PlaceholderPage } from './pages/PlaceholderPage';
import { ItemsPage } from './pages/masters/items/ItemsPage';
import { PartiesPage } from './pages/masters/parties/PartiesPage';
import { LeadMasterPage } from './pages/masters/lead-master/LeadMasterPage';
import { PriceMasterPage } from './pages/masters/price-master/PriceMasterPage';
import { LocationMasterPage } from './pages/masters/locations/LocationMasterPage';
import { MrnPage } from './pages/procurement/mrn/MrnPage';
import { HodPage } from './pages/procurement/hod/HodPage';
import { InvCheckPage } from './pages/procurement/invcheck/InvCheckPage';
import { PrPage } from './pages/procurement/pr/PrPage';
import { PrApprovalPage } from './pages/procurement/pr/PrApprovalPage';
import { RfqPage } from './pages/procurement/rfq/RfqPage';
import { AiAnalysisPage } from './pages/procurement/ai/AiAnalysisPage';
import { QuoteApprovalPage } from './pages/procurement/quoteapproval/QuoteApprovalPage';
import { PoPage } from './pages/procurement/po/PoPage';
import { GrnPage } from './pages/procurement/grn/GrnPage';
import { StockEntryPage } from './pages/procurement/stock/StockEntryPage';
import { CataloguePage } from './pages/sales/catalogue/CataloguePage';
import { OrderSummaryPage } from './pages/sales/order-summary/OrderSummaryPage';
import { OnlineOrdersPage } from './pages/sales/online-orders/OnlineOrdersPage';
import { EcommerceDashboardPage } from './pages/sales/ecommerce-dashboard/EcommerceDashboardPage';
import { EnquiryPage } from './pages/sales/enquiry/EnquiryPage';
import { EnqReviewPage } from './pages/sales/enquiry-review/EnqReviewPage';
import { DispatchOrderPage } from './pages/sales/dispatch-order/DispatchOrderPage';
import { CreditCheckPage } from './pages/sales/credit-check/CreditCheckPage';
import { PickListPage } from './pages/sales/pick-list/PickListPage';
import { PackingPage } from './pages/sales/packing/PackingPage';
import { OutwardGrnPage } from './pages/sales/outward-grn/OutwardGrnPage';
import { SalesReturnPage } from './pages/sales/sales-return/SalesReturnPage';
import { SalesInvoicePage } from './pages/sales/sales-invoice/SalesInvoicePage';
import { GatePassPage } from './pages/sales/gate-pass/GatePassPage';
import { FulfillmentPage } from './pages/sales/fulfillment/FulfillmentPage';
import { WarehouseStockPage } from './pages/inventory/warehouse-stock/WarehouseStockPage';
import { StockAuditPage } from './pages/inventory/stock-audit/StockAuditPage';
import { WhEntryScanPage } from './pages/inventory/wh-entry/WhEntryScanPage';
import { WarehouseLedgerPage } from './pages/inventory/warehouse-ledger/WarehouseLedgerPage';
import { WarehouseSerialPage } from './pages/inventory/warehouse-serial/WarehouseSerialPage';
import { StockAgeingPage } from './pages/inventory/stock-ageing/StockAgeingPage';
import { CustomerOsPage } from './pages/accounts/CustomerOsPage';
import { SupplierOsPage } from './pages/accounts/SupplierOsPage';
import { InvoiceLogsPage } from './pages/accounts/InvoiceLogsPage';
import { SalesRegisterPage } from './pages/accounts/SalesRegisterPage';
import { PurchaseRegisterPage } from './pages/accounts/PurchaseRegisterPage';
import { ReceiptPage, PaymentPage, ContraPage, JournalPage, SalesVoucherPage, PurchaseVoucherPage } from './pages/accounts/books/VoucherRegisterPage';
import { EditLogPage } from './pages/accounts/books/EditLogPage';
import { NotesPage } from './pages/accounts/books/NotesPage';
import { GroupsPage } from './pages/accounts/books/GroupsPage';
import { LedgersPage } from './pages/accounts/books/LedgersPage';
import { VoucherTypesPage } from './pages/accounts/books/VoucherTypesPage';
import { TdsSectionsPage } from './pages/accounts/books/TdsSectionsPage';
import { CostCentresPage } from './pages/accounts/books/CostCentresPage';
import { DayBookPage } from './pages/accounts/reports/DayBookPage';
import { CashBookPage, CashBankBookPage } from './pages/accounts/reports/CashBankPages';
import { TrialBalancePage, GroupWisePage, ExpenseReportPage, IncomeReportPage } from './pages/accounts/reports/GroupReports';
import { ProfitLossPage, BalanceSheetPage } from './pages/accounts/reports/StatementPages';
import { ReceivablePage, PayablePage } from './pages/accounts/reports/OutstandingPages';
import { ClosingStockPage } from './pages/accounts/reports/ClosingStockPage';
import {
  TdsDeductionsPage, TdsSectionReportPage, TdsRatesPage, TdsPartyPage, TdsPanPage, TdsDeductedPage, TdsPayablePage, TdsChallansPage, TdsAdjustPage, TdsReturnPage, TdsForm16aPage, TdsReconciliationPage, TdsOutstandingPage, TdsDuePage, TdsLdcPage, TdsThresholdPage,
} from './pages/accounts/tds/TdsPages';
import {
  GstSalesPage, GstPurchasePage, GstHsnPage, GstRatePage, GstHeadsPage, GstItcPage, GstOutputPage, Gstr1Page, Gstr3bPage, Gst2bPage, GstPortalPage, GstMismatchPage, GstEinvoicePage, GstEwaybillPage,
} from './pages/accounts/gst/GstPages';
import {
  ExpEntryPage, ExpHeadPage, ExpMonthPage, ExpDeptPage, ExpBudgetPage, ExpTdsProfPage, ExpTdsConPage, ExpTdsOtherPage,
} from './pages/accounts/expense/ExpensePages';
import { BrsPage } from './pages/accounts/reconciliation/BrsPage';
import { RecGst2bPage, RecGstPage, RecInvoicePage, RecPartyPage, RecPurchasePage, RecSalesPage, RecTdsPage } from './pages/accounts/reconciliation/RecPages';
import { SisStockPage } from './pages/inventory/sis-stock/SisStockPage';
import { SisTransferPage } from './pages/inventory/sis-transfer/SisTransferPage';
import { DeptTransferPage } from './pages/inventory/dept-transfer/DeptTransferPage';
import { SisSalesPage } from './pages/inventory/sis-sales/SisSalesPage';
import { SisLedgerPage } from './pages/inventory/sis-ledger/SisLedgerPage';
import { SisExceptionsPage } from './pages/inventory/sis-exceptions/SisExceptionsPage';
import { SisAgingPage } from './pages/inventory/sis-aging/SisAgingPage';
import { SisSettlementPage } from './pages/inventory/sis-settlement/SisSettlementPage';
import { SisAnalyticsPage } from './pages/inventory/sis-analytics/SisAnalyticsPage';
import { SisCreditNotePage } from './pages/inventory/sis-credit-note/SisCreditNotePage';
import { SisProfitabilityPage } from './pages/inventory/sis-profitability/SisProfitabilityPage';
import { SisReturnPoolPage } from './pages/inventory/sis-returns/SisReturnPoolPage';
import { SisAssetsMasterPage } from './pages/inventory/sis-assets/SisAssetsMasterPage';
import { SisCommissionPage } from './pages/masters/commission/SisCommissionPage';
import { HsnGstMasterPage } from './pages/masters/hsn-gst/HsnGstMasterPage';
import { FieldOrdersPage } from './pages/inventory/field-orders/FieldOrdersPage';
import { SisDashboardPage } from './pages/inventory/sis-dashboard/SisDashboardPage';
import { LeadDashboardPage } from './pages/sales/lead-dashboard/LeadDashboardPage';
import { EnquiryDashboardPage } from './pages/sales/enquiry-dashboard/EnquiryDashboardPage';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { SettingsPage } from './pages/admin/settings/SettingsPage';
import { ConfigurationsPage } from './pages/admin/settings/configurations/ConfigurationsPage';
import { EmailConfigPage } from './pages/admin/settings/configurations/EmailConfigPage';
import { WhatsAppConfigPage } from './pages/admin/settings/configurations/WhatsAppConfigPage';
import { DocTemplatesPage } from './pages/admin/settings/configurations/DocTemplatesPage';
import { ShopifyConfigPage } from './pages/admin/settings/configurations/ShopifyConfigPage';
import { DelhiveryConfigPage } from './pages/admin/settings/configurations/DelhiveryConfigPage';
import { ShippingPage } from './pages/sales/shipping/ShippingPage';
import { LabelPrintPage } from './pages/sales/shipping/LabelPrintPage';
import { OnlineProfitabilityPage } from './pages/sales/online-profitability/OnlineProfitabilityPage';
import { ShopifyMappingPage } from './pages/admin/settings/configurations/ShopifyMappingPage';
import { ShopifyStockPushPage } from './pages/admin/settings/configurations/ShopifyStockPushPage';
import { UsersPage } from './pages/admin/users/UsersPage';
import { AuditLogsPage } from './pages/admin/audit/AuditLogsPage';
import { RolesPage } from './pages/admin/roles/RolesPage';
import { MecaReportPage } from './pages/reports/MecaReportPage';
import { VendorPortalPage } from './pages/vendor-portal/VendorPortalPage';

/** Modules whose real pages are implemented — others fall back to PlaceholderPage. */
const REAL_PAGES: Record<string, () => JSX.Element> = {
  dashboard: DashboardPage,
  items: ItemsPage,
  parties: PartiesPage,
  'lead-master': LeadMasterPage,
  'price-master': PriceMasterPage,
  locations: LocationMasterPage,
  'sis-commission': SisCommissionPage,
  'hsn-gst-master': HsnGstMasterPage,
  mrn: MrnPage,
  hod: HodPage,
  invcheck: InvCheckPage,
  pr: PrPage,
  'pr-approval': PrApprovalPage,
  rfq: RfqPage,
  ai: AiAnalysisPage,
  quoteapproval: QuoteApprovalPage,
  po: PoPage,
  grn: GrnPage,
  stock: StockEntryPage,
  catalogue: CataloguePage,
  'ecom-dashboard': EcommerceDashboardPage,
  'online-orders': OnlineOrdersPage,
  'shipping': ShippingPage,
  'online-profitability': OnlineProfitabilityPage,
  'shopify-mapping': ShopifyMappingPage,
  'shopify-stock': ShopifyStockPushPage,
  'lead-dashboard': LeadDashboardPage,
  'enquiry-dashboard': EnquiryDashboardPage,
  enq: EnquiryPage,
  'enq-review': EnqReviewPage,
  'dispatch-order': DispatchOrderPage,
  'credit-check': CreditCheckPage,
  'pick-list': PickListPage,
  packing: PackingPage,
  'outward-grn': OutwardGrnPage,
  'sales-return': SalesReturnPage,
  'sp-invoice': SalesInvoicePage,
  'gate-pass': GatePassPage,
  fulfillment: FulfillmentPage,
  'wh-stock': WarehouseStockPage,
  'wh-audit': StockAuditPage,
  'wh-entry': WhEntryScanPage,
  'wh-ledger': WarehouseLedgerPage,
  'wh-serials': WarehouseSerialPage,
  'wh-ageing': StockAgeingPage,
  'dept-transfer': DeptTransferPage,
  'acc-customer-os': CustomerOsPage,
  'acc-supplier-os': SupplierOsPage,
  'acc-invoice-logs': InvoiceLogsPage,
  'rpt-meca': MecaReportPage,
  'acc-sales-register': SalesRegisterPage,
  'acc-purchase-register': PurchaseRegisterPage,
  'acc-receipt': ReceiptPage,
  'acc-payment': PaymentPage,
  'acc-contra': ContraPage,
  'acc-journal': JournalPage,
  'acc-sales': SalesVoucherPage,
  'acc-purchase': PurchaseVoucherPage,
  'acc-notes': NotesPage,
  'acc-edit-log': EditLogPage,
  'acc-groups': GroupsPage,
  'acc-ledgers': LedgersPage,
  'acc-voucher-types': VoucherTypesPage,
  'acc-tds': TdsSectionsPage,
  'acc-cost-centres': CostCentresPage,
  'acc-day-book': DayBookPage,
  'acc-cash-book': CashBookPage,
  'acc-cash-bank-book': CashBankBookPage,
  'acc-trial-balance': TrialBalancePage,
  'acc-profit-loss': ProfitLossPage,
  'acc-balance-sheet': BalanceSheetPage,
  'acc-receivable': ReceivablePage,
  'acc-payable': PayablePage,
  'acc-expense-report': ExpenseReportPage,
  'acc-income-report': IncomeReportPage,
  'acc-group-summary': GroupWisePage,
  'acc-closing-stock': ClosingStockPage,
  'acc-gst-sales': GstSalesPage,
  'acc-gst-purchase': GstPurchasePage,
  'acc-gst-hsn': GstHsnPage,
  'acc-gst-rate': GstRatePage,
  'acc-gst-heads': GstHeadsPage,
  'acc-gst-itc': GstItcPage,
  'acc-gst-output': GstOutputPage,
  'acc-gst-r1': Gstr1Page,
  'acc-gst-3b': Gstr3bPage,
  'acc-gst-2b': Gst2bPage,
  'acc-gst-portal': GstPortalPage,
  'acc-gst-mismatch': GstMismatchPage,
  'acc-gst-einv': GstEinvoicePage,
  'acc-gst-ewb': GstEwaybillPage,
  'acc-exp-entry': ExpEntryPage,
  'acc-exp-head': ExpHeadPage,
  'acc-exp-month': ExpMonthPage,
  'acc-exp-dept': ExpDeptPage,
  'acc-exp-budget': ExpBudgetPage,
  'acc-exp-tds-prof': ExpTdsProfPage,
  'acc-exp-tds-con': ExpTdsConPage,
  'acc-exp-tds-other': ExpTdsOtherPage,
  'acc-rec-brs': BrsPage,
  'acc-rec-gst': RecGstPage,
  'acc-rec-2b': RecGst2bPage,
  'acc-rec-sales': RecSalesPage,
  'acc-rec-tds': RecTdsPage,
  'acc-rec-invoice': RecInvoicePage,
  'acc-rec-purchase': RecPurchasePage,
  'acc-rec-party': RecPartyPage,
  'acc-tds-deductions': TdsDeductionsPage,
  'acc-tds-sections': TdsSectionReportPage,
  'acc-tds-rates': TdsRatesPage,
  'acc-tds-party': TdsPartyPage,
  'acc-tds-pan': TdsPanPage,
  'acc-tds-deducted': TdsDeductedPage,
  'acc-tds-payable': TdsPayablePage,
  'acc-tds-challans': TdsChallansPage,
  'acc-tds-adjust': TdsAdjustPage,
  'acc-tds-return': TdsReturnPage,
  'acc-tds-16a': TdsForm16aPage,
  'acc-tds-rec': TdsReconciliationPage,
  'acc-tds-outstanding': TdsOutstandingPage,
  'acc-tds-due': TdsDuePage,
  'acc-tds-ldc': TdsLdcPage,
  'acc-tds-threshold': TdsThresholdPage,
  'sis-stock': SisStockPage,
  'sis-transfer': SisTransferPage,
  'sis-sales': SisSalesPage,
  'sis-ledger': SisLedgerPage,
  'sis-exceptions': SisExceptionsPage,
  'sis-assets': SisAssetsMasterPage,
  'sis-aging': SisAgingPage,
  'sis-settlement': SisSettlementPage,
  'sis-analytics': SisAnalyticsPage,
  'sis-cn-dn': SisCreditNotePage,
  'sis-profitability': SisProfitabilityPage,
  'sis-return-pool': SisReturnPoolPage,
  'sales-orders-field': FieldOrdersPage,
  'cs-dashboard': SisDashboardPage, // legacy permission id, repurposed as SIS Overview
  settings: SettingsPage,
  configurations: ConfigurationsPage,
  usermgmt: UsersPage,
  rolemgmt: RolesPage,
  'audit-logs': AuditLogsPage,
};

export default function App() {
  return (
    <>
    <Routes>
      {/* Public routes — no sidebar / auth */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/portal/quote/:token" element={<VendorPortalPage />} />
      <Route path="/print/shipping-label/:id" element={<RequireAuth><LabelPrintPage /></RequireAuth>} />

      <Route
        element={
          <RequireAuth>
            <CartProvider>
              <AppLayout />
            </CartProvider>
          </RequireAuth>
        }
      >
        {ALL_ITEMS.map((item) => {
          const Page = REAL_PAGES[item.moduleId] ?? PlaceholderPage;
          return (
            <Route
              key={item.moduleId}
              path={item.path === '/' ? '/' : item.path}
              element={
                <RequireAuth module={item.moduleId}>
                  <Page />
                </RequireAuth>
              }
            />
          );
        })}
        {/* Order Summary — reached via cart's "Place Order" button. Not a sidebar entry. */}
        <Route path="/sales/order-summary" element={<RequireAuth module="enq"><OrderSummaryPage /></RequireAuth>} />
        {/* Configurations sub-routes — no separate permission guard, covered by settings */}
        <Route path="/admin/configurations/email" element={<RequireAuth module="settings"><EmailConfigPage /></RequireAuth>} />
        <Route path="/admin/configurations/whatsapp" element={<RequireAuth module="settings"><WhatsAppConfigPage /></RequireAuth>} />
        <Route path="/admin/configurations/doc-templates" element={<RequireAuth module="settings"><DocTemplatesPage /></RequireAuth>} />
        <Route path="/admin/configurations/shopify" element={<RequireAuth module="settings"><ShopifyConfigPage /></RequireAuth>} />
        <Route path="/admin/configurations/delhivery" element={<RequireAuth module="settings"><DelhiveryConfigPage /></RequireAuth>} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    {/* Logo intro — after sign-in and on logout; lives here so it spans the route change. */}
    <IntroSplash />
    </>
  );
}
